export default class LayerConfiguration {
  public attributeMetadataKey: number;
  public rating: boolean;
  public scale: string; // global or focal
}
